import classNames from 'classnames';
import React, { FC } from 'react';

import { Meter, MeterProps } from 'shared/components/elements/Meter';
import { useTheme } from 'shared/components/utils/Theme';

import css from './LabeledMeter.module.scss';

const BAR_COUNT = 5;

interface LabeledMeterProps extends Partial<MeterProps> {
  meterClassName?: string;
  size?: 'medium' | 'small';
}

export const LabeledMeter: FC<React.PropsWithChildren<LabeledMeterProps>> = ({
  className,
  colors,
  current = 0,
  defaultColor,
  max = 10,
  meterClassName,
  size = 'medium',
}) => {
  const { variables } = useTheme();
  const activeCount = Math.ceil((current * BAR_COUNT) / max);
  const value = activeCount > BAR_COUNT ? BAR_COUNT : Math.round(activeCount);
  const color = variables['--color-error-main'];

  return (
    <div
      className={classNames(css.labeledMeterContainer, className, {
        [css.smallLabeledMeterContainer]: size === 'small',
      })}
    >
      <Meter
        className={classNames(css.labeledMeter, meterClassName, {
          [css.smallLabeledMeter]: size === 'small',
        })}
        colors={colors ?? [color, color]}
        current={value}
        defaultColor={
          defaultColor ?? variables['--color-error-dark-half-opacity']
        }
        max={BAR_COUNT}
      />
      <span
        className={css.labeledMeterCount}
        data-sumo-test='labeled-meter-count'
      >
        {current}
      </span>
    </div>
  );
};
